import type { SharedApiV2 } from "@capstone/mock-api";

export class CarrierType {
  private constructor(args: ClassProperties<CarrierType>) {
    this.id = args.id;
    this.name = args.name;
  }

  public readonly id: number;
  public readonly name: string;

  public static deserialize(data: ApiCarrierType): CarrierType {
    return new CarrierType({ id: data.id, name: data.name });
  }

  public static deserializeList(
    value: ApiCarrierType[],
  ): readonly CarrierType[] {
    return value.map((x) => CarrierType.deserialize(x));
  }

  /**
   * Whether the carrier type is a Less Than Truck Load (LTL) type.
   */
  public isLtl(): boolean {
    return this.name === "LTL";
  }
}

type ApiCarrierType = SharedApiV2.CarrierType;
